<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
    class="top-bar">
    <div>
      <p data-test="count-shows">{{ text }}</p>
    </div>
    <div>
      <a
        data-test="grid-view"
        href="#"
        class="m-r-2"
        @click="$router.push('/listen/my-shows')">
        <img
          :src="displayGrid ? gridOn : gridOff"
          width="24"
          alt="">
      </a>
      <a
        data-test="list-view"
        href="#"
        @click="$router.push('/listen/my-shows/list')">
        <img
          :src="displayList ? listOn : listOff"
          width="24"
          alt="">
      </a>
    </div>
  </el-row>
</template>
<script>
import listOn from '../assets/images/ic_list_on.svg';
import listOff from '../assets/images/ic_list_off.svg';
import gridOn from '../assets/images/ic_grid_on.svg';
import gridOff from '../assets/images/ic_grid_off.svg';

export default {
  name: 'LibraryMenu',
  props: {
    displayGrid: {
      type: Boolean,
      default: false,
    },
    displayList: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      listOn,
      listOff,
      gridOn,
      gridOff,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
  .top-bar {
    padding: 36px 0;
    margin: 0 64px;
    p {
      font-size: 24px;
      color: $black;
    }
  }
  @media (max-width: 576px) {
    .top-bar {
      margin: 12px 32px !important;
    p {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/LibraryMenu.vue